// extracted by mini-css-extract-plugin
export default {"header":"UGtmXIEPjXfgAw7ILSli","title":"bPh2OreZuHxcPlGd6wwu","createButton":"_Z1gw8HUb1rBmFVYxjdK","storefrontCollectionListContainer":"HnNA03xYf1X3KeOKo0g6"};